/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Chiedi assistenza al tuo team o al tuo amministratore.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Impossibile recuperare i risultati di questa ricerca',
};
